import React from 'react';
import {minutesToFormatted} from "../dynamic-form/TimeTrackingField";
import classNames from "classnames";
import {scoreColors} from "../../analytics/color-scheme";



function getDefaultComment(defaultComments, rating) {
  return defaultComments
    && defaultComments.find(df => df.rating == rating)
    && defaultComments.find(df => df.rating == rating).comment
}

function isNumber(n){
    return Number(n)=== n;
}

function parseTimeSpend(ts) {
    let timeSpend = ts;
    let timeSpendTmp = timeSpend;
    if (!isNumber(timeSpend) && timeSpend && timeSpend.includes(':')) {
        timeSpendTmp = (parseInt(timeSpend.split(':')[0]) * 60) + parseInt(timeSpend.split(':')[1])
    } else {
        timeSpendTmp = parseInt(timeSpend);
    }

    if (!isNaN(timeSpendTmp)) {
        return minutesToFormatted(timeSpendTmp)
    }

    return minutesToFormatted(0)
}

const RatingMultiElement = ({
                              rating,
                              scale,
                              ratingPrompt,
                              notObservedPrompt,
                              notResponsivePrompt,
                              notObserved,
                              notResponsive,
                              comment,
                              timeSpend,
                              defaultComments,
                              timeSpendFieldPrompt,
                              useNoNr,
                              observationComment,
                              overrideDefaultScores,
                              scoreOverrides,
                              author,
                              acknowledger
                            }) => {
  const range = Array.from(Array(parseInt(scale, 10)).keys());
  // console.log('responsesForAck', useNoNr, notObservedPrompt, notResponsivePrompt, notObserved, notResponsive)
  return (
    <div className='dynamic-report-item'>
      <div className='label' style={{whiteSpace: 'pre-wrap'}}>
        {ratingPrompt}
      </div>
      {(!!observationComment) && (
        <div className="field" style={{borderBottom: '1px solid #f3f6f8', marginBottom: '10px', paddingBottom: '5px'}}>
          {!author && <div>Observation comment</div>}
          {author && <div style={{color: '#22358d', fontStyle: 'italic'}}>{author} Commented</div>}
          {observationComment
            ? <span style={{whiteSpace: 'pre-line', unicodeBidi: 'embed'}} dangerouslySetInnerHTML={{__html: observationComment}}></span>
            : <span>No comment</span>
          }
        </div>
      )}
      {rating !== 0 && !overrideDefaultScores &&
      <div className='field rating-field'>
        {range.map((r, index) => (
          <div className="rating-multi-response">
            {index < rating
              ? <i key={r} className='fa fa-star'/>
              : <i key={r} className='fa fa-star-o'/>}
            <div className="star-number">{index + 1}</div>
          </div>
        ))}
        </div>
      }
      {rating !== 0 && overrideDefaultScores &&
      <div className={classNames('field rating-field')} style={{backgroundColor: scoreColors[rating], color: '#fff', padding: '5px 10px', borderRadius: '4px', display: 'inline-block', fontSize: '0.9em'}}>
        {scoreOverrides[rating] || rating}
      </div>
      }
      { useNoNr && notObserved && (
        <div className="field field-with-icon">
          <i className="fa fa-check-square-o"/>
          <span className="response">{notObservedPrompt}</span>
        </div>
      )}
      { useNoNr && notResponsive && (
        <div className="field field-with-icon response">
          <i className="fa fa-check-square-o"/>
          <span className="response">{notResponsivePrompt}</span>
        </div>
      )}
      {timeSpend && (
        <div>{timeSpendFieldPrompt || 'Time spend on this observation'} {parseTimeSpend(timeSpend)}</div>
      )}
      {/*{defaultComment && (*/}
        {/*<div className="field field-with-icon">*/}
          {/*<i className="fa fa-comment"/>*/}
          {/*<span style={{wordWrap: 'break-word'}}>{defaultComment}</span>*/}
        {/*</div>*/}
      {/*)}*/}
      { (!!comment) && (
        <div className="field" style={{borderTop: '1px solid #f3f6f8', marginTop: '10px', paddingTop: '5px'}}>
          {acknowledger && (
            <div style={{color: '#7c6408'}}><i>{acknowledger} Commented</i></div>
          )}
          { comment
            ? <p style={{whiteSpace: 'pre-line', unicodeBidi: 'embed'}}  dangerouslySetInnerHTML={{__html: comment}}></p>
            : <span>No comment</span>
          }
        </div>
      )}
    </div>
  );
};

export default RatingMultiElement;
